export default __webpack_public_path__ + "static/media/biote_rapid.2fbbbe89.png";